import { render, staticRenderFns } from "./addNewShift.vue?vue&type=template&id=d5a9e6be&scoped=true&"
import script from "./addNewShift.vue?vue&type=script&lang=js&"
export * from "./addNewShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a9e6be",
  null
  
)

export default component.exports